const VueFileUploader = {
    install: function (Vue/*, options*/) {
        const fileuploader = window['$fileuploader'];

        Vue.prototype.$fileuploader = fileuploader
    }
}

export default VueFileUploader
